import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

export const usePaymentConfig = (open) => {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!open) return;
    const controller = new AbortController();
    setConfig(null);
    setError(false);
    axios.get(`${API}/payments/config`, { signal: controller.signal })
      .then(({ data }) => { if (!controller.signal.aborted) setConfig(data); })
      .catch(() => { if (!controller.signal.aborted) setError(true); });
    return () => controller.abort();
  }, [open, attempt]);
  return { config, error, retry: () => setAttempt((value) => value + 1) };
};